// core
import React from "react";
import { useFormikContext } from "formik";

// hooks
import useSettingsValidation from "../../hooks/useSettingsValidation";

// components
import Input from "../../../common/components/Forms/Input/Input";
import ToolTip from "../../../common/components/Tooltips/Tooltip";

// interfaces
import { IQuoteSettings } from "../../interfaces/form/IQuoteSettings";
import { IStreamlineSettingsClientProps } from "./StreamlineBaseClientSettings";
import ProductType from "../../../common/interfaces/enums/ProductType";

const StreamlineTraumaSettings: React.FC<IStreamlineSettingsClientProps> = (props) => {
    const { client, name } = props;
    const { handleBlur, setFieldValue } = useFormikContext<IQuoteSettings>();
    const { getFormikError } = useSettingsValidation();

    return (
        <div className="layout-flex-row--justify-spaced gap-l">
            <Input
                name={`${name}.${ProductType.Trauma}.coverAmount`}
                label={`Cover amount`}
                type={`number`}
                hasCurrency
                value={client[ProductType.Trauma]?.coverAmount}
                onBlur={handleBlur}
                onChange={(e) =>
                    setFieldValue(`${name}.${ProductType.Trauma}.coverAmount`, e)
                }
                hasError={getFormikError(`${name}.${ProductType.Trauma}.coverAmount`)}>
                <ToolTip
                    className="gap-pre-xl space-pre-xl"
                    size={"xl"}
                    tooltipContent={
                        "Common uses for Trauma Cover are help with medical bills, take time off work to recover, and to pay off a mortgage or debt."
                    }
                />
            </Input>
        </div>
    );
};

export default StreamlineTraumaSettings;
